module.exports = __webpack_public_path__ + "img/header_bg.67e53e49.png";